import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import { Heading } from '../../Heading';
import { AccordionContext, ACCORDION_TYPE } from '../Accordion';
import styles from '@dtsl/css-accordion/dist/index.module.css';
import { ChevronUp, ChevronDown } from '@dtsl/icons';
function AccordionPanel(props) {
  const {
    panelContent,
    onClick,
    itemIdx,
    className = ''
  } = props;
  const {
    visibleAccordionItems,
    setVisibleAccordionItems,
    accordionType
  } = useContext(AccordionContext);

  // isPanelContentNode === true, implies that panelContent is a HTML node and not an object.
  const isPanelContentNode = /*#__PURE__*/React.isValidElement(panelContent);
  const handleAllOpenable = clickedItemIdx => {
    setVisibleAccordionItems(prevState => {
      const newVisibilityOfAccordions = [...prevState];
      newVisibilityOfAccordions[clickedItemIdx] = !newVisibilityOfAccordions[clickedItemIdx];
      return newVisibilityOfAccordions;
    });
  };
  const handleSingleOpenable = clickedItemIdx => {
    setVisibleAccordionItems(prevState => {
      const newVisibilityOfAccordions = prevState.map((isVisible, index) => index === clickedItemIdx ? !isVisible : false);
      return newVisibilityOfAccordions;
    });
  };
  const handleAccordionClick = e => {
    e.preventDefault();
    accordionType === ACCORDION_TYPE.MULTI_OPENABLE ? handleAllOpenable(itemIdx) : handleSingleOpenable(itemIdx);
    onClick(e, itemIdx);
  };
  const panelContentClasses = classNames({
    [styles['sib-accordion__panel-content']]: true,
    [className]: !!className
  });
  const standardPanelBody = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: panelContentClasses
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "sm",
    level: 2
  }, (panelContent === null || panelContent === void 0 ? void 0 : panelContent.title) || ''), /*#__PURE__*/React.createElement("p", {
    className: styles['sib-accordion__help-text']
  }, panelContent === null || panelContent === void 0 ? void 0 : panelContent.helpText)));
  const panelWrapperClasses = classNames({
    [styles['sib-accordion__panel']]: true,
    [styles['sib-accordion__panel--clickable']]: !isPanelContentNode
  });
  return isPanelContentNode ? /*#__PURE__*/React.createElement("div", {
    className: panelWrapperClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: panelContentClasses,
    id: `accordionItem-${itemIdx}`
  }, panelContent), /*#__PURE__*/React.createElement(Button, {
    iconAlone: true,
    ariaLabel: "button",
    "aria-describedby": `accordionItem-${itemIdx}`,
    "aria-expanded": visibleAccordionItems[itemIdx] ? 'true' : 'false',
    icon: visibleAccordionItems[itemIdx] ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null),
    variant: "tertiary",
    onClick: handleAccordionClick
  })) : /*#__PURE__*/React.createElement("button", {
    className: panelWrapperClasses,
    "aria-expanded": visibleAccordionItems[itemIdx] ? 'true' : 'false',
    onClick: handleAccordionClick
  }, standardPanelBody, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-accordion__arrow']
  }, visibleAccordionItems[itemIdx] ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null)));
}
AccordionPanel.propTypes = {
  panelContent: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({
    title: PropTypes.string.isRequired,
    helpText: PropTypes.string
  })]).isRequired,
  onClick: PropTypes.func,
  itemIdx: PropTypes.number,
  className: PropTypes.string
};
export default AccordionPanel;